import ConfirmationModal from './modals/confirmation-modal/confirmation-modal';

export enum MODALS {
  CONFIRM = 'CONFIRM_DELETE',
}

export const MODAL_COMPONENTS = {
  [MODALS.CONFIRM]: ConfirmationModal,
};
